import {lazy} from 'react';

export const VirtualAboutAsync = lazy(() =>
    import('./VirtualAbout')
);
